import { Grid, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';

const TextFiltrosNotasEvaluativasComponent = ({ docenteSelect }) => {
  const notasEvaluativasStore = Redux.useSelector(
    (state) => state.notasEvaluativas,
  );

  const loginStore = Redux.useSelector((state) => state.login);
  const seccionesStore = Redux.useSelector((state) => state.secciones);
  const materiasStore = Redux.useSelector((state) => state.materias);

  const [seccion, setSeccion] = React.useState(null);
  const [materia, setMateria] = React.useState(null);

  React.useEffect(() => {
    if (docenteSelect && notasEvaluativasStore.params.idSeccion) {
      const seccionFind = docenteSelect.secciones.find(
        (el) => el.id === notasEvaluativasStore.params.idSeccion,
      );
      setSeccion(seccionFind);
    } else {
      const seccionFind = seccionesStore.all.find(
        (el) => el.id === notasEvaluativasStore.params.idSeccion,
      );
      setSeccion(seccionFind);
    }
    if (docenteSelect && notasEvaluativasStore.params.idMateria) {
      const materiaFind = docenteSelect.materias.find(
        (el) => el.id === notasEvaluativasStore.params.idMateria,
      );
      setMateria(materiaFind);
    } else {
      const materiaFind = materiasStore.all.find(
        (el) => el.id === notasEvaluativasStore.params.idMateria,
      );
      setMateria(materiaFind);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notasEvaluativasStore.params]);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <Stack direction="row" sx={{}}>
          {!loginStore.isTeacher && (
            <>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Docente:</strong>{' '}
                {docenteSelect && notasEvaluativasStore.params.idDocente ? (
                  <label>
                    {docenteSelect.usuario.perfil.pnombre}{' '}
                    {docenteSelect.usuario.perfil.papellido}
                  </label>
                ) : (
                  'Todos'
                )}
              </Typography>
            </>
          )}

          {materia && (
            <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
              <strong>Materia:</strong> {materia.nombre}
            </Typography>
          )}

          {seccion && (
            <Stack direction="row" sx={{}}>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Nivel:</strong>{' '}
                {seccion.nivelAcademico?.nivelAcademico?.nombre ?? '--'}
              </Typography>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Sección:</strong> {seccion.nombre}
              </Typography>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Turno:</strong> {seccion.turno}
              </Typography>
            </Stack>
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default TextFiltrosNotasEvaluativasComponent;
